import type { Context as SharedContext } from '../shared/context';
import type { DataRetentionRuleInterface } from '../data_retention_rules/data_retention_rule';

type NotificationOption = {
  value: number;
  label: string;
};

export type Context = SharedContext & {
  onGetNotificationData: any;
  notificationOptions: Array<NotificationOption>;
  rules: Array<DataRetentionRuleInterface>;
};

const defaultContext = {
  edited: false,
  editing: false,
  editingRuleId: null,
  errors: {},
  loaded: false,
  meta: {
    all_offices_path: '',
    candidate_data_path: '',
    notifications_path: '',
    update_rules_path: '',
    new_rule_path: '',
    pagination: {
      current_page: null,
      next_page: null,
      per_page: null,
      previous_page: null,
      total_entries: null,
      total_pages: null,
    },
  },
  notificationOptions: [],
  rules: [],
  onAdd: () => {},
  onCancel: () => {},
  // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
  onDelete: (rule) => {},
  // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
  onEdit: (rule) => {},
  // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
  onFieldChange: (field) => {},
  onGetNotificationData: () => {},
  // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
  onSave: (rule) => {},
} as const;

// @ts-expect-error - TS2686 - 'React' refers to a UMD global, but the current file is a module. Consider adding an import instead.
export const DataRetentionRulesContext = React.createContext(defaultContext);
